import { atom } from 'recoil';

export const ciAuthUidAtom = atom<string | null>({
  key: 'ciAuthUidAtom',
  default: null,
});
